import React from 'react';
import * as S from './Loader.styles';

const ButtonLoader = ({loaderType}) => {
    switch(loaderType){
        case 'button':
            return <S.ButtonLoader><div></div><div></div><div></div><div></div></S.ButtonLoader>
        case 'gstin': 
            return <S.GstinLoader><div></div><div></div><div></div><div></div></S.GstinLoader>;
        default:
            null;
    }
}

export default ButtonLoader;